<div class="flex flex-column flex-center-center gap-4">
  <app-icon color="#22C55E" [size]="42" [name]="iconName"></app-icon>
  <p class="fs-sm text-semibold">{{title}}</p>
  <p class="fs-xs">{{description}}</p>
</div>
